module.exports = __webpack_public_path__ + "media/images/recruit/mv/img-mark-01-b9d9a7d9cf0effdd29f0b6f08254e572.svg";